import apollo from '@/apollo.js'
import gql from 'graphql-tag'
import cfg from '@/cfg.js'

const ssoApiBase = () => String(cfg.apiEndPoint() || "").replace(/\/+$/, "")

export const getSsoConfig = async () => {
  try {
    const response = await fetch(ssoApiBase() + "/sso/oidc/config")
    if (!response.ok) {
      return { enabled: false, buttonLabel: "Sign in with SSO", disablePasswordLogin: false }
    }
    const data = await response.json()
    return {
      enabled: !!(data && data.enabled),
      buttonLabel: (data && data.buttonLabel) || "Sign in with SSO",
      disablePasswordLogin: !!(data && data.disablePasswordLogin)
    }
  } catch (err) {
    return { enabled: false, buttonLabel: "Sign in with SSO", disablePasswordLogin: false }
  }
}

export const exchangeSsoSession = async (code) => {
  try {
    const response = await fetch(ssoApiBase() + "/sso/oidc/session", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ code })
    })
    const data = await response.json().catch(() => null)
    if (!response.ok || !data || data.error || !data.accessToken) {
      return {
        error: true,
        message: (data && data.message) || "SSO sign-in could not be completed."
      }
    }
    return {
      accessToken: data.accessToken,
      refreshToken: data.refreshToken,
      mfaPending: !!data.mfaPending,
      next: data.next
    }
  } catch (err) {
    return { error: true, message: "SSO sign-in could not be completed." }
  }
}

export const getToken = async (cred) => {
  try {
    const response = await apollo.mutate(
      {
        mutation: gql(`
          mutation CreateSession($email: String!, $password: String!) {
            createSession(email: $email, password: $password) {
              jwToken
              accessToken
              refreshToken
              mfaPending
              message
              error
            }
          }`),
        variables: { email: cred.username, password: cred.password }
      })
    if (response && response.data && response.data.createSession && (response.data.createSession.accessToken || response.data.createSession.jwToken)) {
      return {
        token: response.data.createSession.accessToken || response.data.createSession.jwToken,
        refreshToken: response.data.createSession.refreshToken,
        error: undefined,
        mfaPending: response.data.createSession.mfaPending,
      }
    } else {
      return { token: undefined, refreshToken: undefined, error: new Error("Unable to login due to invalid credentials") }
    }
  } catch (err) {
    return { token: undefined, refreshToken: undefined, error: err }
  }
}

export const verifyTOTP = async (totp) => {
  try {
    const response = await apollo.mutate(
      {
        mutation: gql(`
          mutation verifyTOTP($totp: String!) {
            verifyTOTP(totp: $totp) {
              jwToken
              accessToken
              refreshToken
              mfaPending
              message
              error
            }
          }`),
        variables: { totp }
      })
    if (response && response.data && response.data.verifyTOTP) {
      if (response.data.verifyTOTP.error) {
        return { token: undefined, refreshToken: undefined, error: {message: response.data.verifyTOTP.message} }
      } else {
        return {
          token: response.data.verifyTOTP.accessToken || response.data.verifyTOTP.jwToken,
          refreshToken: response.data.verifyTOTP.refreshToken,
          error: undefined,
          mfaPending: response.data.verifyTOTP.mfaPending,
        }
      }
    }
  } catch (err) {
    return { token: undefined, refreshToken: undefined, error: err }
  }
}